<template>
  <div class="d-flex centered">
    <div class="d-lg-flex d-none align-items-center">
      <p data-aos="zoom-in" class="skill__text">Skills</p>
    </div>
    <div class="col-lg-10 col-12">
      <div class="row">
        <SkillCard name="Java" />
        <SkillCard name="C#" icon-name="c-sharp" />
        <SkillCard name="Python" />
        <SkillCard name="TypeScript" />
        <SkillCard name="HTML" />
        <SkillCard name="CSS" />
        <SkillCard name="React" />
        <SkillCard name="React Native" icon-name="react" />
        <SkillCard name="Vue" />
        <SkillCard name="Next" add-image-padding />
        <SkillCard name="Node" />
        <SkillCard name="Django" />
        <SkillCard name="Kotlin" add-radius />
        <SkillCard name="SQL" />
        <SkillCard name="PostgreSQL" />
        <SkillCard name="MongoDB" />
        <SkillCard name="AWS" />
        <SkillCard name="Firebase" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SkillCard from '@/components/about/SkillCard.vue';
</script>

<style lang="scss" scoped>
.left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.skill__text {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  transform: rotate(-90deg);
  text-decoration: underline;
  text-decoration-color: var(--green);
  text-underline-offset: 10px;
  margin-right: 40px;
}
</style>
